module.exports = __webpack_public_path__ + "img/Strip-Front-B5-Jb.f498ffc7.png";